module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03-m-en.58413afa4465016a39abdbb52bf07d11.png";